import { useQuery } from '@tanstack/react-query';

import { RequestOptions, axios } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';
import { APIResponse } from '@/common/types';

type GetViewTokenResponse = APIResponse<{ viewToken: string }>;

export const getPublicSubdomainViewToken = (options?: RequestOptions): Promise<GetViewTokenResponse> => {
    return axios.get('/fetch/get-view-token', { params: { domain: 'spotters' }, ...options });
};

type UsePublicSubdomainViewTokenOptions = {
    config?: QueryConfig<typeof getPublicSubdomainViewToken>;
};

export const usePublicSubdomainViewToken = ({ config }: UsePublicSubdomainViewTokenOptions = {}) => {
    return useQuery<GetViewTokenResponse>({
        ...config,
        queryKey: ['public-view-token'],
        queryFn: ({ signal }) => getPublicSubdomainViewToken({ signal }),
    });
};
